"use strict";

exports.__esModule = true;
exports.AdvancedTimelineFieldSelector = AdvancedTimelineFieldSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _AdvancedTimelineContext = require("./AdvancedTimelineContext");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _SelectorOption = require("./SelectorOption");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function placeholder(translate, showAllFields) {
  if (showAllFields) {
    return translate("AdvancedTimelineFields.FieldSelector.label", "Select Fields");
  }
  return translate("AdvancedTimelineFields.DimensionSelector.label", "Select Dimensions");
}
function AdvancedTimelineFieldSelector(props) {
  var timelines = _react["default"].useContext(_AdvancedTimelineContext.AdvancedTimelineContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? true : _props$multiple,
    _props$showAllFields = props.showAllFields,
    showAllFields = _props$showAllFields === void 0 ? false : _props$showAllFields;
  var selectedTimeline = timelines.find(function (timeline) {
    return timeline.type === element.props.timeline;
  });
  if (!selectedTimeline) {
    return null;
  }
  var dimensions = selectedTimeline.fields.filter(function (field) {
    return showAllFields || new RegExp("dimension.", "gi").test(field);
  }).filter(function (field) {
    return !!field;
  });
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: placeholder(translate, showAllFields)
  }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    multiple: multiple,
    items: dimensions,
    getKey: function getKey(dimension) {
      return dimension;
    },
    selected: element.props.dimensions ? element.props.dimensions : [],
    onSelect: function onSelect(selectedDimensions) {
      return elementEditor.setProp(path, "dimensions", selectedDimensions);
    },
    renderItemText: function renderItemText(dimension) {
      return /*#__PURE__*/_react["default"].createElement(_SelectorOption.SelectorOption, {
        value: selectedTimeline.fieldLabels[dimension],
        parentComponent: "AdvancedTimelineDimensionSelector"
      });
    },
    placeholder: placeholder(translate)
  }));
}